export default __webpack_public_path__ + "static/media/yerba_buena.6f0bde06.jpg";